function useMarginClassNames(margins?: marginOrPadding): string[] {
    if (!margins) {
        return [];
    }

    const classNames: string[] = [];

    if (typeof margins === "string") {
        classNames.push(
            `margin-top-${margins}`,
            `margin-right-${margins}`,
            `margin-bottom-${margins}`,
            `margin-left-${margins}`,
        );
    }
    
    if (typeof margins === "object" && "x" in margins) {
        classNames.push(`margin-right-${margins.x}`, `margin-left-${margins.x}`);
    } 
    if (typeof margins === "object" && "y" in margins) {
        classNames.push(`margin-top-${margins.y}`, `margin-bottom-${margins.y}`);
    }
    
    if (typeof margins === "object" && "top" in margins) {
        classNames.push(`margin-top-${margins.top}`);
    }
    if (typeof margins === "object" && "right" in margins) {
        classNames.push(`margin-right-${margins.right}`);
    }
    if (typeof margins === "object" && "bottom" in margins) {
        classNames.push(`margin-bottom-${margins.bottom}`);
    }
    if (typeof margins === "object" && "left" in margins) {
        classNames.push(`margin-left-${margins.left}`);
    }

    return classNames;
}

export default useMarginClassNames;
